import { Module } from 'vuex'
import { RegistryStoreState } from '@/modules/RegistryModule/store/registry-store.model'
import { RootStoreState } from '@/store/root/root-store.model'
import { VtStore } from '@/store/vt-store'

const initialRegistryStoreState =
    (): RegistryStoreState => ({
        showPreviousCases: false,
        searcherEntityState: null,
        fixFieldsContent: {},
        fixFieldsToggle: false,
        sampleGridFixFieldsContent: {},
        sampleGridFixFieldsToggle: false
    })

const module: Module<RegistryStoreState, RootStoreState> = {
    namespaced: true,
    state: initialRegistryStoreState,
    getters: {
        showPreviousCases: (state): boolean => state.showPreviousCases,
        searcherEntityState: (state): any => state.searcherEntityState,
        fixFieldsContent: (state): any => state.fixFieldsContent,
        fixFieldsToggle: (state): boolean => state.fixFieldsToggle,
        sampleGridFixFieldsContent: (state): any => state.sampleGridFixFieldsContent,
        sampleGridFixFieldsToggle: (state): boolean => state.sampleGridFixFieldsToggle
    },
    mutations: {
        updateShowPreviousCases: (state: RegistryStoreState, payload: boolean): void => { state.showPreviousCases = payload },
        updateSearcherEntityState: (state: RegistryStoreState, payload: any): void => { state.searcherEntityState = payload },
        updateFixFieldsContent: (state: RegistryStoreState, payload: any): void => { state.fixFieldsContent = payload },
        updateFixFieldsToggle: (state: RegistryStoreState, payload: boolean): void => { state.fixFieldsToggle = payload },
        updateSampleGridFixFieldsContent: (state: RegistryStoreState, payload: any): void => { state.sampleGridFixFieldsContent = payload },
        updateSampleGridFixFieldsToggle: (state: RegistryStoreState, payload: boolean): void => { state.sampleGridFixFieldsToggle = payload }
    }
}
export const registryStore = new VtStore<RegistryStoreState>('registry', module)
